import { composeIO } from 'react-compose-io'
import { tabelaOPSIO } from './TabelaOPS.IO'
import TabelaOPSView from './TabelaOPS.View'

export const TabelaOPS = composeIO(TabelaOPSView, tabelaOPSIO)
